import React from 'react'
import styled from 'styled-components'

type Props = {
  SvgComponent:
    | React.FC<React.SVGProps<SVGSVGElement>>
    | React.ComponentType<Record<string, unknown>>
  width?: number
  height?: number
  defaultColor?: string
  hoverColor?: string
}

const GenericSvgIcon: React.FC<Props> = ({ SvgComponent }) => {
  return (
    <Container className="svg-icon-wrapper">
      <SvgComponent width="100%" height="100%" />
    </Container>
  )
}

export default GenericSvgIcon

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`
